import React, { createContext, useState } from 'react';
import api from '../services/api';

interface AuthDataIpiranga {
  token: string;
  getToken(): Promise<string>;
}

export const AuthIppContext = createContext<AuthDataIpiranga>({
  token: '',
  getToken: async () => '',
});

const config = {
  params: {
    client_id: `${process.env.REACT_APP_CLIENT_ID}`,
    client_secret: `${process.env.REACT_APP_CLIENT_SECRET}`,
    grant_type: 'client_credentials',
  },
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};

export const AuthIppProvider: React.FC = ({ children }) => {
  const [lastDate, setLastDate] = useState(0);
  const [token, setToken] = useState('');
  const [expiresIn, setExpiresIn] = useState(0);

  async function getToken() {
    const expirationDate = new Date(lastDate).setSeconds(expiresIn);

    if (!!token && expirationDate > Date.now()) {
      return token;
    }

    const {
      data: { access_token, expires_in },
    } = await api.post(
      `${process.env.REACT_APP_URl_TOKEN}`,
      {
        data: {
          grant_type: 'client_credentials',
        },
      },
      config,
    );

    setToken(access_token);
    setExpiresIn(expires_in);
    setLastDate(Date.now());

    return access_token;
  }

  return (
    <AuthIppContext.Provider value={{ token, getToken }}>
      {children}
    </AuthIppContext.Provider>
  );
};
